module.exports = __webpack_public_path__ + "static/img/refine1.ec46c81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/refine1.png
// module id = q6+Q
// module chunks = 0